import React from "react";
import CommonSection from "../components/UI/CommonSection";
import Helmet from "../components/Helmet/Helmet";
import AboutSection from "../components/UI/AboutSection";
import { Container, Row, Col } from "reactstrap";
import OurMembers from "../components/UI/OurMembers";
import { useTranslation } from "../hooks/useTranslation";
import "../styles/about.css";
import driveImg from "../assets/all-images/slider-img/slider-1.jpg";
import AboutSection1 from "../components/UI/AboutSection1";

const About = () => {
  const t = useTranslation();

  return (
    <Helmet title={t("about.title")}>
      <CommonSection title={t("about.commonsection")} />
      <AboutSection aboutClass="aboutPage" />
      <AboutSection1 aboutClass="aboutPage" />


     

      {/* Values Section */}
      <section className="values__section d-flex justify-content-center align-items-center">
        <Container>
          <div className="section-header text-center">
            <h6>{t("services.learnMore")}</h6>
            <h2>{t("hero.slide2.title")}</h2>
          </div>
          <Row className="justify-content-center">
            {[
              {
                icon: "ri-shield-check-line",
                title: t("services.rental.title"),
                desc: t("services.rental.desc"),
              },
              {
                icon: "ri-star-line",
                title: t("services.contracting.title"),
                desc: t("services.contracting.desc"),
              },
             
            ].map((value, index) => (
              <Col lg="3" md="6" className="mb-4 d-flex justify-content-center" key={index}>
                <div className="value-card text-center">
                  <div className="card-icon">
                    <i className={value.icon}></i>
                  </div>
                  <h3>{value.title}</h3>
                  <p>{value.desc}</p>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>
    </Helmet>
  );
};

export default About;
